import { render } from "./CustomerPersonalInfo.vue?vue&type=template&id=feef242e"
import script from "./CustomerPersonalInfo.vue?vue&type=script&lang=js"
export * from "./CustomerPersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__